import { render, staticRenderFns } from "./PrivacyStatementView.vue?vue&type=template&id=7fcd2b2b&scoped=true"
import script from "./PrivacyStatementView.vue?vue&type=script&lang=js"
export * from "./PrivacyStatementView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyStatementView.vue?vue&type=style&index=0&id=7fcd2b2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd2b2b",
  null
  
)

export default component.exports